<template>
    <div class="cargameRank-tabComponent">
        <div class="position-relative items-center top-headerBoxIn">
            <div class="backToApp" id="close" @click="viewClose('someStatus')"><div class="angle white-angle"></div></div>
            <div class="text-center text-white agencyCentre-headerHD">Rank</div>
        </div>
        <div class="listToggle">
            <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item">
                    <div class="nav-link" :class="{ 'active': activeTab === 'thisweek' }" @click="activateTab('thisweek')"
                        data-toggle="tab" href="#thisweek" role="tab">Today</div>
                </li>
                <li class="nav-item">
                    <div class="nav-link" :class="{ 'active': activeTab === 'lastweek' }"
                        @click="activateTab('lastweek')" data-toggle="tab" href="#lastweek" role="tab">Yesterday
                    </div>
                </li>
            </ul>
        </div>
        <div class="tab-content">
            <div class="tab-pane" :class="{ 'active': activeTab === 'thisweek' }" id="thisweek" role="tabpanel">
                <div class="tab-contentIn" v-if="isLoadedThisweek">
                    <RankThisweekComponent />
                </div>
            </div>
            <div class="tab-pane" :class="{ 'active': activeTab === 'lastweek' }" id="lastweek" role="tabpanel">
                <div class="tab-contentIn" v-if="isLoadedLastweek">
                    <RankLastweekComponent />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { viewClose as androidViewClose } from '@/utils/android';
import './CarGame.css'
import RankThisweekComponent from "./RankThisweekComponent.vue"
import RankLastweekComponent from "./RankLastweekComponent.vue"
export default {
    name: 'RankTabComponent',
    components: {
        RankThisweekComponent,
        RankLastweekComponent
    },
    data(){
        return {
            activeTab: 'thisweek',
            isLoadedThisweek: false,
            isLoadedLastweek: false,
        }
    },
    methods: {
        activateTab(tabId) {
            this.activeTab = tabId;
            if (tabId === 'thisweek' && !this.isLoadedThisweek) {
                this.isLoadedThisweek = true;
            }
            if (tabId === 'lastweek' && !this.isLoadedLastweek) {
                this.isLoadedLastweek = true;
            }
        },
        viewClose(status) {
            if (window.navigator.userAgent.indexOf("Android") > -1) {
                androidViewClose(status);        
            }
        }
    },
    mounted() {
        this.isLoadedThisweek = true;
    },
}
</script>